import { subscribe, unsubscribe, type PageEnvironmentConnectionState } from '@seamless/one-context';
import { initializeStore } from '@seamless/store';
import { slashJoin, withTrailingSlash } from 'path-slashes';

import { seamlessStoreFns } from 'src/app/store/common/common.utils';
import { ExecutionMode } from 'src/app/utils/models/execution-mode.enum';

const OWCC_AEM_PLUGIN_NAME_PATH = 'owcc-fe';

export async function initOptionalSeamlessEnv(win: Window): Promise<{ withSeamless: boolean }> {
  return new Promise<{ withSeamless: boolean }>(resolve => {
    if (seamlessStoreFns.isSeamlessStoreAvailable(win)) {
      const store = initializeStore();
      subscribe<PageEnvironmentConnectionState>('PageConnection', {
        tenant: OWCC_AEM_PLUGIN_NAME_PATH,
        componentName: OWCC_AEM_PLUGIN_NAME_PATH,
        callback: (state: PageEnvironmentConnectionState) => {
          win.owcc = {
            ...win.owcc,
            version: store.version,
            mode: ExecutionMode.Integrated,
            /*
            seamless provides the base asset uri for all plugins, our plugin is called `owcc-fe` (see name in manifest).
            Therefore, we have to add our plugin name to the base asset uri
             */
            assetUri: withTrailingSlash(slashJoin(state.environmentVariables.assetUri, OWCC_AEM_PLUGIN_NAME_PATH)),
            country: state.pageEnvironmentVariables.country,
            language: state.pageEnvironmentVariables.language
          };
          resolve({ withSeamless: true });
        }
      });
    } else {
      resolve({ withSeamless: false });
    }
  }).then((result: { withSeamless: boolean }) => {
    if (result.withSeamless) {
      unsubscribe('PageConnection', {
        tenant: OWCC_AEM_PLUGIN_NAME_PATH,
        componentName: OWCC_AEM_PLUGIN_NAME_PATH
      });
    }
    return result;
  });
}
